module.exports = __webpack_public_path__ + "static/kuruyemis.d-8ff62960b24c9692d1d4de3329a127ff.webp";